export default __webpack_public_path__ + "static/media/gray_large.319b549d.png";